import * as Sentry from '@sentry/vue';

import router from '~/router';

export default {
  install: (app) => {
    const sentryDsn = document.querySelector(
      'meta[name="plugin-sentry-dsn"]'
    )?.content;
    if (!sentryDsn) return;

    const sentryEnv = document.querySelector(
      'meta[name="plugin-sentry-env"]'
    )?.content || 'development';

    const tracesSampleRate = parseFloat(
      document.querySelector(
        'meta[name="plugin-sentry-traces-sample-rate"]'
      )?.content || '0.1'
    );

    const targetsByEnvironment = {
      development: ["localhost", /^https:\/\/dev-clubs\.local\//],
      alpha:       [/^https:\/\/clubs-alpha\.wusa\.ca\//],
      staging:     [/^https:\/\/clubs-staging\.wusa\.ca\//],
      production:  [/^https:\/\/clubs\.wusa\.ca\//],
    };    

    try {
      Sentry.init({
        app,
        dsn: sentryDsn,
        environment: sentryEnv,
        sendDefaultPii: false,
        tracesSampleRate,
        tracePropagationTargets: targetsByEnvironment[sentryEnv],
        replaysSessionSampleRate: 0.05,
        replaysOnErrorSampleRate: 1.0,
        environment: process.env.NODE_ENV,
        release: __APP_VERSION__,
        integrations: [
          Sentry.browserTracingIntegration({ router }),
          Sentry.replayIntegration(),
          Sentry.vueIntegration({
            tracingOptions: {
              trackComponents: true,
            }
          })          
        ],
      });
    } catch (sentryInitError) {
      console.warn(
        'Sentry initialization failed:',
        sentryInitError
      );
    }
  },
};